/**
* Created by lobin on 2020/6/12.
*/
<template>
  <div class="home">
    <a-row :gutter="16">
      <a-col span="6">
        <a-card :loading="todayLoading">
          <a-statistic title="派件入站" :value="today.pks" style="margin-right: 50px">
            <template #suffix>
              <a-icon type="like" />
            </template>
          </a-statistic>
        </a-card>
      </a-col>
      <a-col span="6">
        <a-card :loading="todayLoading">
          <a-statistic title="快递员增加" :value="today.partner" style="margin-right: 50px">
            <template #suffix>
              <a-icon type="like" />
            </template>
          </a-statistic>
        </a-card>
      </a-col>
      <a-col span="6">
        <a-card :loading="todayLoading">
          <a-statistic title="粉丝增加" :value="today.user" style="margin-right: 50px">
            <template #suffix>
              <a-icon type="like" />
            </template>
          </a-statistic>
        </a-card>
      </a-col>
      <a-col span="6">
        <a-card :loading="todayLoading">
          <a-statistic title="营收" :value="today.income" style="margin-right: 50px">
            <template #suffix>
              <a-icon type="like" />
            </template>
          </a-statistic>
        </a-card>
      </a-col>
    </a-row>
    <a-card :loading="historyLoading" style="margin: 20px 0; padding: 0">
      <a-row :gutter="16">
        <div style="text-align: right">
          <h3 style="float: left">数据统计及排行</h3>
          <a-radio-group v-model="date" @change="onChange">
            <a-radio :value="1">
              最近7天
            </a-radio>
            <a-radio :value="2">
              最近30天
            </a-radio>
            <a-radio :value="3" disabled>
              自定义
            </a-radio>
          </a-radio-group>
          <a-range-picker v-model="dateRange" valueFormat="YYYY-MM-DD" @change="dateChange" :allowClear="false"/>
        </div>
        <a-divider />
        <a-col :span="18" class="chart">
          <h4>站点派件量统计</h4>
          <v-chart :force-fit="true" :height="height" :data="dataList" :scale="scale">
            <v-tooltip />
            <v-axis />
            <v-legend />
            <v-line position="day*temperature" color="city" />
            <v-point position="day*temperature" color="city" :size="4" :v-style="style" :shape="'circle'" />
          </v-chart>
        </a-col>
        <a-col :span="6">
          <h4>投递量排行</h4>
          <a-list
            :split="false"
            size="small"
            item-layout="horizontal"
            :data-source="range">
            <a-list-item slot="renderItem" slot-scope="item,index">
                <a-badge
                  :number-style="{
                    backgroundColor: '#314659',
                    color: '#fff',
                  }"
                  :count="index + 1" v-if="index < 3"/>
                <a-badge
                  v-else
                  :count="index + 1"
                  :number-style="{
                    backgroundColor: '#f5f5f5',
                    color: '#333',
                  }"
                />
                <span style="padding-left: 24px; flex: 1">{{ item.name }}</span>
                <span style="float: right">{{ item.num }}</span>
            </a-list-item>
          </a-list>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script type="text/babel">
import moment from 'moment';
import DataSet from '@antv/data-set';
import { todayStatistic, stationRange, historyStatistic } from '@/api/statistic';

const scale = [{
  dataKey: 'day',
  min: 0,
  max: 1,
}];

export default {
  data() {
    return {
      todayLoading: true,
      historyLoading: false,
      today: {},
      dataList: [],
      scale,
      height: 400,
      style: { stroke: '#fff', lineWidth: 1 },
      date: '',
      range: [],
      dateRange: [],
    };
  },
  created() {
    this.getToday();
    this.setDefault();
    this.getStatics();
  },
  methods: {
    async getToday() {
      this.todayLoading = true;
      const { data } = await todayStatistic();
      data.income = data.income.toFixed(2);
      this.today = data;
      this.todayLoading = false;
    },
    setDefault() {
      const yesToday = moment().subtract(1, 'day').format('YYYY-MM-DD');
      const lastWeek = moment().subtract(8, 'days').format('YYYY-MM-DD');
      this.dateRange = [lastWeek, yesToday];
      this.date = 1;
    },
    onChange() {
      const val = this.date;
      const yesToday = moment().subtract(1, 'day').format('YYYY-MM-DD');
      const lastWeek = moment().subtract(8, 'days').format('YYYY-MM-DD');
      const last30days = moment().subtract(31, 'days').format('YYYY-MM-DD');
      if (val === 1) {
        this.dateRange = [lastWeek, yesToday];
        this.getStatics();
      }
      if (val === 2) {
        this.dateRange = [last30days, yesToday];
        this.getStatics();
      }
      if (val === 3) {
        this.dateRange = [];
      }
    },
    setDate(sourceData) {
      const dv = new DataSet.View().source(sourceData);
      dv.transform({
        type: 'fold',
        fields: ['pks', 'profit'],
        key: 'city',
        value: 'temperature',
      });
      const data = dv.rows;
      this.dataList = data;
    },
    dateChange() {
      this.date = 3;
      this.getStatics();
    },
    async getRange() {
      const start = this.dateRange[0];
      const end = this.dateRange[1];
      const { data } = await stationRange({ start, end });
      this.range = data;
    },
    async getHistory() {
      const start = this.dateRange[0];
      const end = this.dateRange[1];
      const { data } = await historyStatistic({ start, end });
      this.setDate(data);
    },
    async getStatics() {
      this.historyLoading = true;
      try {
        await this.getRange();
        await this.getHistory();
      } catch (e) {
        console.log(e);
      }
      this.historyLoading = false;
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
  .home {

  }
  .chart{
    canvas{
      max-width : 100% !important;
    }
  }
</style>
